import { Toolbar, IconButton, LinearProgress, makeStyles } from "@material-ui/core";
import { NavigateNext, NavigateBefore } from "@material-ui/icons";
import React, { useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const useStyles = makeStyles({
  documentContainer: {
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    height: "inherit",
    "& .react-pdf__Page__canvas": {
      margin: "0 auto"
    }
  },
  document: {
    height: "inherit"
  },
  page: {
    overflowX: "auto",
    overflowY: "hidden"
  }
});

const PdfPreview = ({ documentUrl, pageChanged = () => {} }) => {
  const classes = useStyles();
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);

  const onPrevPage = () => {
    setPage(page - 1);
  };

  const onNextPage = () => {
    pageChanged({ page: page + 1, totalPages });
    setPage(page + 1);
  };

  const onLoadSuccess = ({ numPages }) => {
    setTotalPages(numPages);
  };

  return (
    <div id="pdfDiv" className={classes.documentContainer}>
      <Document file={documentUrl} onLoadSuccess={onLoadSuccess} className={classes.document}>
        <Page
          className={classes.page}
          pageNumber={page}
          height={document.getElementById("pdfDiv")?.clientHeight * 0.85 ?? 150}
        />
      </Document>
      <Toolbar>
        <IconButton disabled={page <= 1} onClick={onPrevPage}>
          <NavigateBefore />
        </IconButton>
        <IconButton disabled={page >= totalPages} onClick={onNextPage}>
          <NavigateNext />
        </IconButton>
        <LinearProgress
          style={{ width: "100%" }}
          variant="determinate"
          value={((page - 1) / (totalPages - 1)) * 100}
        />
      </Toolbar>
    </div>
  );
};

export default PdfPreview;
